import React, { useEffect, useCallback} from 'react'
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import './embla.css'
import image1 from '../assets/MenuCalculators/Laser P.png'
import image2 from '../assets/MenuCalculators/Fibre Optics P.png'
import image3 from '../assets/MenuCalculators/Diffuse Reflection P.png'
import image4 from '../assets/MenuCalculators/LookUp Table P.png'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'


const EmblaCarousel = (props) => {

    const content = [
        {
            title: "Point & Extended",
            description: "The point source has a laser emission from a single point and has a miniscule diameter compared with the viewing distance while an extended source is the opposite with laser emitted from various points and a relatively large diameter.",
            image: image1,
            alt: "Point & Extended"
        },
        {
            title: "Fiber Optic",
            description: "Utilises flexible quartz or glass fibres that use total internal reflection to pass light through thousands of glancing reflections. Optical sources typically used are laser diodes, LEDs and VCSEL (Vertical Cavity Surface Emitting Laser).",
            image: image2,
            alt: "Fiber Optic"
        },
        {
            title: "Diffuse Reflection",
            description: "This happens when different parts of a beam strike a surface and reflects over a wide range of angles. The reflection typically strikes a rough or irregular surface.",
            image: image3,
            alt: "Diffuse Reflection"
        },
        {
            title: "Lookup Table",
            description: "Find out the accessible emission limit for all laser class in relation to the laser wavelength you want to calculate. Evaluate the laser properties to determine safety values for eye and skin.",
            image: image4,
            alt: "Lookup Table"
        }
    ]
    const [emblaRef, emblaApi] = useEmblaCarousel({loop: true}, [Autoplay({ delay: 3000, stopOnInteraction: false })])

    useEffect(() => {
        if (!emblaApi) return

        const updateSlideClasses = () => {
            const selectedIndex = emblaApi.selectedScrollSnap()
            const slideNodes = emblaApi.slideNodes()
            const slideCount = slideNodes.length

            const prevIndex = (selectedIndex - 1 + slideCount) % slideCount
            const nextIndex = (selectedIndex + 1) % slideCount

            slideNodes.forEach((slide, index) => {
                slide.classList.remove("is-prev", "is-next")
                if (index === prevIndex) slide.classList.add("is-prev")
                if (index === nextIndex) slide.classList.add("is-next")
            })
        }

        emblaApi.on("select", updateSlideClasses)
        updateSlideClasses()
    }, [emblaApi])

    const onNavButtonClick = useCallback((emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }, [])

    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(
        emblaApi,
        onNavButtonClick
    )

    return (
        <section className="embla">
            <div className="embla__viewport" ref={emblaRef}>
                <div className="embla__container">
                    {content.map((content, index) => (
                        <div className="embla__slide" key={index}>
                            <div className="embla__slide__number">
                                <div id="card_content" className='card_content' onMouseEnter={()=>emblaApi?.plugins()?.autoplay.stop()} onMouseLeave={()=>emblaApi?.plugins()?.autoplay.play()}>
                                    {<img src={content.image} alt={content.alt} width={"100%"} />}
                                    <div class='description_box'>
                                        <div >
                                            <h1>{content.title}</h1>
                                            <p>{content.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="embla__controls">
                <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                            key={index}
                            onClick={() => onDotButtonClick(index)}
                            className={'embla__dot'.concat(
                                index === selectedIndex ? ' embla__dot--selected' : ''
                            )}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default EmblaCarousel
